// @flow
import React, { PureComponent } from 'react';
import Loading from 'components/fragments/Loading';
import { STATUS_DEFAULT, STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import CF7Form from 'containers/contactForm7/CF7FormContainer';
import type { SingleContactFormType } from 'types/ContactForm7';
import type { Status } from 'types/Status';

import H3Title from './titles/h3Title';

export type StateProps = {
  singleContactForm: SingleContactFormType,
  sendStatus: Status,
  fetchSingleStatus: Status
};

export type DispatchProps = {
  fetchSingleCF7FormContact: (id: number) => void,
  resetCF7ContactFormStatus: () => void
};

type Props = StateProps &
  DispatchProps & {
    formId: number,
    title?: string,
    titleClass?: string,
    titleTag?: string,
    initialValues: { [key: string]: any }
  };

class ContactForm7 extends PureComponent<Props> {
  props: Props;

  componentDidMount = () => {
    const { fetchSingleCF7FormContact, formId } = this.props;

    if (formId && formId !== -1) {
      fetchSingleCF7FormContact(formId);
    }
  };

  componentDidUpdate(prevProps: Props) {
    const { formId: prevFormId, sendStatus: prevSendStatus } = prevProps;
    const { fetchSingleCF7FormContact, formId, sendStatus, resetCF7ContactFormStatus } = this.props;

    if (prevSendStatus === STATUS_LOADING && sendStatus === STATUS_SUCCESS) {
      resetCF7ContactFormStatus();
    }

    if (!!formId && formId !== -1 && prevFormId !== formId) {
      fetchSingleCF7FormContact(formId);
    }
  }

  /**
   * le composant doit être rendu :
   * - au montage lorsqu'on reçoit formId du parent
   * - au status loading de fetchSingleStatus
   * - lorsque fetchSingleStatus reviens à Success
   * - chaque fois que singleContactForm est modifié - @todo à améliorer
   */
  render() {
    const { fetchSingleStatus, sendStatus, singleContactForm, title, titleClass, titleTag, initialValues } = this.props;

    if (fetchSingleStatus === STATUS_DEFAULT || fetchSingleStatus === STATUS_LOADING || sendStatus === STATUS_LOADING) {
      return <Loading isWhite />;
    }

    return (
      <>
        {typeof title === 'string' && titleTag === 'h3' && <H3Title title={title} titleClass={titleClass} />}
        <CF7Form {...singleContactForm} initialValues={initialValues} />
      </>
    );
  }
}

export default ContactForm7;
